'use strict'

import './_polyfills.js'
import { scrollToPosition, scrollToElement } from './utils.js'

// import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes'
// import 'focus-visible'

import conditioner, { idle } from '@parallaxagency/conditioner'

conditioner.addPlugin({
  moduleSetName: name => `./components/${name}.js`,
  moduleGetConstructor: module => module.default,
  moduleImport: name =>
    import(/* webpackChunkName: 'conditioner' */ `${name}`)
})
conditioner.addPlugin(idle)
conditioner.hydrate(document.documentElement)

var body = document.querySelector('body');
var nav = document.querySelector('nav');
var modal = document.querySelector('.modal');
var overlay = document.querySelector('.overlay');
var menu_toggles = document.querySelectorAll('.burger, .menu a');
var modal_toggles = document.querySelectorAll('.js-open-modal, .js-close-modal');
var scroll_to_buttons = document.querySelectorAll('.js-scroll-to');
var video = {};
var microlance = {};

function init()
{
  var r = microlance;
  r.swatch_bg = document.querySelector('#color-picker');
  r.swatch_bg_text = document.querySelector('#color-picker .bg-text');
  r.swatches = document.querySelectorAll('.swatch');
  r.lance_images = document.querySelectorAll('.lance');

  for(var i = 0; i < r.swatches.length; ++i)
  {
    var s = r.swatches[i];
    s.addEventListener('click', on_swatch_click);
  }

  for(var i = 0; i < menu_toggles.length; ++i)
  {
    var t = menu_toggles[i];
    t.addEventListener('click', toggle_menu);
  }

  for(var i = 0; i < modal_toggles.length; ++i)
  {
    var t = modal_toggles[i];
    t.addEventListener('click', toggle_modal);
  }

  for(var i = 0; i < scroll_to_buttons.length; ++i)
  {
    var b = scroll_to_buttons[i];
    b.addEventListener('click', scrollTo)
  }

  video.container = document.querySelector('.video')
  video.player = document.querySelector('video')
  video.button = document.querySelector('.video .play')

  video.container.addEventListener('click', toggle_video);
  video.player.addEventListener('ended', toggle_video);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        toggle_video({ type: 'click' })
        observer.disconnect()
      }
    })
  }, { rootMargin: '-400px' })

  observer.observe(video.player)

  overlay.addEventListener('click', close_interfaces);

  window.addEventListener('scroll', toggle_nav_contrast)
  toggle_nav_contrast()
}

function scrollTo (e)
{
  e.preventDefault()

  let id = e.target
    .closest('.js-scroll-to')
    .getAttribute('href')
    .substr(1)

  if (id === '') {
    scrollToPosition(0)
    return
  }

  let $target = document.getElementById(id)
  scrollToElement($target)
}

function toggle_nav_contrast(e)
{
  if(window.scrollY > window.innerHeight / 4) {
    nav.classList.add('with-contrast')
  } else {
    nav.classList.remove('with-contrast')
  }

}

function toggle_menu(e)
{
  if(body.classList.contains('menu-open')) {
    body.classList.remove('menu-open');
  } else {
    body.classList.add('menu-open');
    body.classList.remove('modal-open');
  }
}

function toggle_video(e)
{
  switch(e.type)
  {
    case 'click':
      video.player.play();
      video.button.style.display = 'none';
    break;
    case 'ended':
      video.button.style.display = 'flex';
    break;
  }
}

function toggle_modal(e)
{
  var content_id = e.target.getAttribute('data-article') || false
  if(content_id) {
    var content = document.querySelector('template[data-article="' + content_id + '"]').innerHTML
    modal.innerHTML = content
    body.classList.add('modal-open');
  } else {
    body.classList.remove('modal-open');
  }
}

function close_interfaces(e)
{
  body.classList.remove('modal-open', 'menu-open');
}

function on_swatch_click(e)
{
  var r = microlance;
  var el = e.target;

  for(var i = 0; i < r.swatches.length; ++i)
    r.swatches[i].classList.remove('active');

  for(var i = 0; i < r.lance_images.length; ++i)
    r.lance_images[i].classList.remove('active');

  el.classList.add('active');

  var col = el.getAttribute('color');
  r.swatch_bg.setAttribute('color', col);

  switch(col)
  {
    case 'yellow':

      r.swatch_bg_text.innerHTML = 'YELLOW';
      r.lance_images[3].classList.add('active');

    break;
    case 'blue':

      r.swatch_bg_text.innerHTML = 'BLUE';
      r.lance_images[2].classList.add('active');

    break;
    case 'grey':

      r.swatch_bg_text.innerHTML = 'GREY';
      r.lance_images[1].classList.add('active');

    break;
    case 'orange':

      r.swatch_bg_text.innerHTML = 'ORANGE';
      r.lance_images[0].classList.add('active');

    break;
  }
}

window.addEventListener('load', init);



// WEBPACK FOOTER //
// ./src/js/main.js